import { ChangeDetectionStrategy, Component } from '@angular/core'

/**
 * GbGooglePayIconComponent
 *
 * Recommended padding is already added to the icon, so resize the entire component as needed.
 *
 * More info on the icon here: https://developers.google.com/pay/api/web/guides/brand-guidelines#style
 */
@Component({
  selector: 'gb-google-pay-icon',
  templateUrl: './gb-google-pay-icon.component.html',
  styleUrls: ['./gb-google-pay-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class GbGooglePayIconComponent {}
